import { Box, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';

/**
 * Skeleton loader for data tables
 *
 * @param {Object} props - Component props
 * @param {number} props.rows - Number of skeleton rows (default: 5)
 * @param {number} props.columns - Number of columns (default: 5)
 * @param {boolean} props.showSearch - Whether to show search skeleton
 */
const TableSkeleton = ({ rows = 5, columns = 5, showSearch = true }) => (
  <Box>
    {/* Search bar skeleton */}
    {showSearch && (
      <Skeleton
        variant="rounded"
        width={250}
        height={40}
        sx={{ mb: 2 }}
      />
    )}

    {/* Table skeleton */}
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <Table>
        <TableHead>
          <TableRow>
            {Array.from({ length: columns }).map((_, index) => (
              <TableCell key={index}>
                <Skeleton variant="text" width="80%" height={24} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton
                    variant="text"
                    width={colIndex === 0 ? '90%' : '70%'}
                    height={20}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  </Box>
);

export default TableSkeleton;
